import { NodeJob } from './node-job';

export interface PowerShellJob extends NodeJob {
    script: string;
}
